import { Select } from 'antd5';
import styled from 'styled-components';

export const StyledSelect = styled(Select)`
  width: 50%;
  min-width: 130px;
`;

export const StyledMultiSelect = styled(Select)`
  width: calc(100% - 290px);
  min-width: 300px;
`;
